import { render, staticRenderFns } from "./CDRQOwnerView.vue?vue&type=template&id=3f636904&scoped=true&"
import script from "./CDRQOwnerView.vue?vue&type=script&lang=ts&"
export * from "./CDRQOwnerView.vue?vue&type=script&lang=ts&"
import style0 from "./CDRQOwnerView.vue?vue&type=style&index=0&id=3f636904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f636904",
  null
  
)

export default component.exports